(ns main.specs
  (:require
   [cljs.spec.alpha :as s]
   [entities.specs :as entities]
   [accounts.specs :as accounts]
   [authentication.specs :as authentication]
   [dashboard.specs :as dashboard]
   [guidebook.specs :as guidebook]
   [profile.specs :as profile]
   [priorities.specs :as priorities]
   [router.specs :as router]))
    ;[modal.specs :as modal]


;; @TODO "how do we define [some-known-path some-unknown variable-number
;; of-paths]"
(s/def ::navigation-context #{["overview"]
                              ["profile"]
                              ["accounts"]
                              ["team"]
                              ["resources"]})

(s/def ::paths (s/or :known ::navigation-context
                     :unknown (s/coll-of string?)))
(s/def ::current string?)
(s/def ::uri (s/keys :req-un [::current
                              ::paths]))
(s/def ::authentication-status #{:authenticating :authenticated :unauthenticated})

(s/def ::id (s/and string? #(not (empty? %1))))
(s/def ::name (s/and string? #(not (empty? %))))

(s/def ::client (s/keys :req-un [::id
                                 ::name]))
(s/def ::clients (s/coll-of ::client
                            :distinct true))

;; account-allocation
(s/def ::allocation (s/keys :req-un [::percent
                                     ::strategy
                                     ::total-value]))
;; fix me: (s/def ::percent (s/and float? pos? #(<= % 100)))
;; fix me: (s/def ::total-value float?)
;; fix me: (s/def ::strategy (s/and string? #(not (empty? %))))
(s/def ::account-allocation (s/coll-of ::allocation))
;; /account-allocation

;; average-performance
(s/def ::month-td float?)
(s/def ::quarter-td float?)
(s/def ::year-td float?)
(s/def ::average-performance (s/keys :req-un [::month-td
                                              ::quarter-td
                                              ::year-td]))
;; /average-performance

(s/def ::total-value number?)
(s/def ::assets number?)
(s/def ::liabilities number?)
(s/def ::total-performance (s/keys :req-un [::total-value ::assets ::liabilities]))


(s/def ::loaded? boolean?)
(s/def ::fetch-error? boolean?)
(s/def ::fetch-attempts int?)
(s/def ::application-loader (s/keys :opt-un [::loaded?
                                             ::fetch-error?
                                             ::fetch-attempts]))

(s/def ::root-spec (s/keys
                    :req-un [::authentication-status
                             :router/route-table]
                    :opt-un [::account-allocation
                             ::accounts/accounts
                             ::accounts/quovo
                             ::application-loader
                             ::authentication/authentication
                             ::average-performance
                             ::clients
                             ::dashboard/dashboard
                             ::entities/entities
                             ::guidebook/guidebook
                             ::priorities/financial-priorities
                             ::profile/personal-information
                             ::profile/profile
                             ::profile/income
                             ::quovo-connections
                             ::total-performance
                             ::uri
                             ::router]))

